<template>
    <div>

        <div class="mt-5 mb-5 valid-button" v-if="!isValid && !readOnly">

            <div class="title-valid-button">
                <v-icon color="warning">warning</v-icon>
                Informations manquantes
            </div>

            <!-- Alertes -->
            <div class="mt-3">
                <div v-if="account.configurations.organism === null">
                    Le nom de votre structure est requis.
                </div>

                <div v-if="account.configurations.cgu === null">
                    Vos CGU ne sont pas renseignées.
                </div>

                <div v-if="account.configurations.logo === null">
                    Votre logo n'est pas renseigné.
                </div>

                <div v-if="!account.configurations.oneSender">
                    Vous devez vérifier au moins une adresse email émetteur auprès de notre service d'envoi d'e-mail.
                </div>

                <div v-if="sender === null">
                    Vous devez renseigner la <span class="span-link" @click="changeStep">boîte d'envoi</span>.
                </div>

                <div v-if="subject === '' || subject == null">
                    Vous devez renseigner l'<span class="span-link" @click="changeStep">objet</span>
                    de l'e-mail envoyé aux prestataires.
                </div>

                <div v-if="firstPartEmail === '' || firstPartEmail == null">
                    Vous devez renseigner la
                    <span class="span-link" @click="changeStep">1ère partie</span>
                    de l'e-mail envoyé aux prestataires.
                </div>

                <div v-if="lastPartEmail === '' || lastPartEmail == null">
                    Vous devez renseigner la
                    <span class="span-link" @click="changeStep">2nd partie</span>
                    de l'e-mail envoyé aux prestataires.
                </div>
            </div>
        </div>

        <div class="mt-5 mb-5 valid-button">
            <div class="title-valid-button">
                <v-icon color="primary">list</v-icon>
                Les options de la campagne
            </div>
            <div class="mt-3 d-flex flex-row">
                <div class="col">
                    <div v-if="!isRevival">
                        Envoi d'e-mails :
                        <span v-if="noEmail" class="text-danger">Désactivé</span>
                        <span v-else class="text-success">Activé</span>
                    </div>
                    <div v-else>
                        Envoi d'e-mails :
                        <span class="text-success">Activé</span>
                    </div>

                    <div>
                        Un seul e-mail par destinataire :
                        <span v-if="singleEmail" class="text-success">Activé</span>
                        <span v-else class="text-danger">Désactivé</span>
                    </div>

                    <div v-if="hasSuggestionOption">
                        Suggestion d'informations :
                        <span v-if="mediaSuggestion" class="text-success">Activé</span>
                        <span v-else class="text-danger">Désactivé</span>
                    </div>

                    <div>
                        Spécificités des périodes :
                        <span v-if="periodsConfig === 'DEFAULT'" class="text-success">Pré-remplies</span>
                        <span v-else-if="periodsConfig === 'EMPTY'" class="text-success">Non pré-remplies</span>
                        <span v-else-if="periodsConfig === 'SUGGESTIONS'" class="text-success">Suggestions</span>
                    </div>
                </div>

                <div class="col" v-if="criterias !== undefined && criterias.length && selectedCriterias.length">
                    Critères internes sélectionnés :
                    <div class="row">
                        <div v-for="criteria in criterias.filter( item => selectedCriterias.includes(item.id))"
                             :key="criteria.id">
                            <v-chip class="p-2 m-2 bg-primary text-white">
                                {{ criteria.libelle }}
                            </v-chip>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="valid-button mb-5" v-if="!readOnly">
            <div class="title-valid-button" v-if="!isRevival">
                Planification du 1er envoi
            </div>
            <div class="title-valid-button" v-else>
                Planification de l'envoi
            </div>
            <div class="mt-3">
                Nombre de fiches présentes dans le groupe d'envoi :
                <span class="text-success">{{emailsValid.length}}</span>
            </div>
            <div class="mt-3 row">
                <div class="col-6">
                    <v-dialog v-model="openStart" persistent max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field :class="{ 'disabled-content': !isValid }"
                                          :label="!isRevival ? 'Date de 1er envoi' : 'Date de l\'envoi'" :value="sentAt"
                                          readonly
                                          outlined v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker locale="fr-FR" color="primary" @change="saveSent"
                                       :first-day-of-week="1">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="openStart = false">Annuler</v-btn>
                            <v-btn text color="primary" @click="openStart = false">Valider</v-btn>
                        </v-date-picker>
                    </v-dialog>
                </div>

                <div class="col-6">
                    <v-menu v-model="menuHour" :close-on-content-click="false" :return-value.sync="time" ref="menu"
                            max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field :value="time" label="Heure d'envoi" prepend-icon="access_time" readonly
                                          @input="updateTime" :class="{ 'disabled-content': !isValid }" outlined
                                          v-on="on">
                            </v-text-field>
                        </template>
                        <v-time-picker color="primary" v-if="menuHour" v-model="time" full-width
                                       @click:minute="$refs.menu.save(time)" format="24hr">
                        </v-time-picker>
                    </v-menu>
                </div>
            </div>
        </div>

        <div class="d-flex gap-20 justify-content-end my-3" v-if="!readOnly">
            <v-btn class="default-button" v-if="!updateMode && !isRevival" @click="save('DRAFT')">
                <v-icon class="mr-3">save</v-icon>
                Enregistrer en brouillon
            </v-btn>

            <v-btn id="finalize-campaign" class="default-button"
                   :disabled="!isValid || sentAt === null || time === null" v-if="!updateMode"
                   @click="save('WAIT_FIRST_SENT')">
                Finaliser la campagne
            </v-btn>

            <v-btn class="default-button" :disabled="!isValid || sentAt === null" v-else-if="updateMode && !isRevival"
                   @click="save('WAIT_FIRST_SENT')">
                Mettre à jour
            </v-btn>

            <v-btn class="default-button" :disabled="!isValid || sentAt === null" v-else-if="updateMode && isRevival"
                   @click="updateRevival">
                Mettre à jour
            </v-btn>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "Finalize",
    props: ["providers", "cmajName", "isRevival", "cmajId", "updateMode", "batchId", "cmaj", "criterias", "readOnly",
    'hasSuggestionOption', "aspect"],
    data() {
        return {
            openStart: false,
            today: null,
            time: "08:00",
            menuHour: false,
            withFilter: false,
        }
    },
    methods: {
        ...mapMutations("createCmaj", ["setSentAt", "setCurrentStep",]),
        save(state) {
            let dateTime = null

            if (this.sentAt !== null) {
                dateTime = this.sentAt
            }

            if (this.time !== null && dateTime !== null) {
                dateTime += " " + this.time
            }

            let providerIds = this.selectedApidaeSelection === null ?
              this.emailsValid.map(provider => provider.id) : []

            let payload = {
                name: this.cmajName,
                providerIds: providerIds,
                fieldIds: this.getFieldIds(),
                senderId: this.sender.id,
                subject: this.subject,
                firstPartEmail: this.firstPartEmail,
                lastPartEmail: this.lastPartEmail,
                signature: this.signature,
                sentAt: dateTime,
                mediaSuggestion: this.mediaSuggestion,
                periodsConfig: this.periodsConfig,
                state: state,
                withFilter: this.withFilter,
                tags: this.selectedTags,
                communes: this.selectedCommunes,
                tourismSectors: this.selectedTourismSectors,
                categories: this.selectedCategories,
                apidaeSelection: this.selectedApidaeSelection,
                criterias: this.selectedCriterias,
                noEmail: this.noEmail,
                singleEmail: this.singleEmail,
                aspect: this.aspect,
                txtIntro: this.txtIntro,
                editedTabulations: this.editedTabulations,
            }

            if (this.cmaj !== undefined) {
                payload.cmajId = this.cmaj.id
            }

            if (this.isRevival && !this.updateMode) {
                this.saveRevival(payload)
            } else if (this.cmaj !== undefined && (this.cmaj.state.code === "DRAFT" || this.updateMode)) {
                this.$global.loading = true

                this.$http.post("auth/campaigns/cmaj/update", payload).then(res => {
                    this.$global.loading = false

                    this.$router.push("/campaigns")
                })
            } else {
                this.$global.loading = true

                this.$http.post("auth/campaigns/cmaj/create", payload).then(res => {
                    this.$global.loading = false

                    this.$router.push("/campaigns")
                })
            }
        },
        saveRevival(payload) {
            delete payload.providerIds

            payload.cmajId = this.cmajId

            this.$global.loading = true

            this.$http.post("auth/campaigns/cmaj/revival/create", payload).then(res => {
                this.$global.loading = false

                this.$router.push("/campaigns")
            })
        },
        updateRevival() {
            let dateTime = this.$moment(this.sentAt, "DD-MM-YYYY").format("YYYY-MM-DD")

            if (this.time !== null) {
                dateTime += " " + this.time
            }

            let payload = {
                name: this.cmajName,
                subject: this.subject,
                firstPartEmail: this.firstPartEmail,
                lastPartEmail: this.lastPartEmail,
                sentAt: dateTime,
                batchId: this.batchId,
                mediaSuggestion: this.mediaSuggestion,
                periodsConfig: this.periodsConfig,
                senderId: this.sender.id,
                signature: this.signature,
                criterias: this.selectedCriterias,
                noEmail: this.noEmail,
                singleEmail: this.singleEmail,
                txtIntro: this.txtIntro,
                editedTabulations: this.editedTabulations,
            }

            this.$global.loading = true

            this.$http.post("auth/campaigns/cmaj/revival/update", payload).then(res => {
                this.$global.loading = false

                this.$router.push("/campaigns")
            })
        },
        getFieldIds() {
            let fieldsArray = Object.values(this.selectedFields)
            fieldsArray = [].concat.apply([], fieldsArray)

            return fieldsArray.map(field => {
                return {
                    new_title: field.new_title,
                    help_description: field.help_description,
                    id: field.field_id,
                    required: field.required,
                }
            })
        },
        changeStep() {
          if(this.currentStep === '6' || this.cmaj === undefined) {
            this.setCurrentStep(parseInt(this.currentStep) - 2)
          } else {
            this.setCurrentStep(parseInt(this.currentStep) - 1)
          }
        },
        saveSent(value) {
            this.openStart = false

            let date = this.$moment(value).format("DD-MM-YYYY")

            this.setSentAt(date)
        },
        updateTime(value) {
            if (value === "") {
                this.time = null
            }
        },
    },
    computed: {
        ...mapState("createCmaj", [
            "sender",
            "subject",
            "firstPartEmail",
            "lastPartEmail",
            "signature",
            "sentAt",
            "selectedFields",
            "emailsValid",
            "currentStep",
            "mediaSuggestion",
            "periodsConfig",
            "selectedCategories",
            "selectedCommunes",
            'selectedTourismSectors',
            "selectedTags",
            "selectedApidaeSelection",
            "selectedCriterias",
            "noEmail",
            "singleEmail",
            'selectedTourismSectors',
            'txtIntro',
            'emailsValid',
            'editedTabulations'
        ]),
        ...mapState("account", ["account"]),
        isValid() {
            return this.account.configurations.logo !== null &&
              this.account.configurations.cgu !== null &&
              this.account.configurations.organism !== null &&
              this.account.configurations.oneSender &&
              this.subject !== "" &&
              this.subject !== null &&
              this.firstPartEmail !== "" &&
              this.firstPartEmail !== null &&
              this.lastPartEmail !== "" &&
              this.lastPartEmail !== null
        },
    },
    watch: {
        noEmail() {},
        singleEmail() {},
        mediaSuggestion() {},
        selectedCriterias() {},
    },
    created() {
        this.today = this.$moment().format("YYYY-MM-DD")

        this.withFilter = this.$route.path.includes("create-scratch") || this.$route.path.includes("duplicate")
          || (this.cmaj !== undefined && this.cmaj.with_filter)

        let sentAt = this.sentAt

        if (sentAt !== undefined && sentAt !== null) {
            let date = this.$moment(sentAt).format("DD-MM-YYYY")

            this.setSentAt(date)

            this.time = this.$moment(sentAt).format("HH:mm")
        }

        if (this.isRevival && !this.updateMode) {
            let date = null

            this.setSentAt(date)

            this.time = null
        }
    },
}
</script>
